import {
  hasStatusForDisableCcmModule,
  hasStatusForDisableRpmModule,
  hasStatusForReadonlyCcmModule,
  hasStatusForReadonlyRpmModule,
} from 'infrastructure/functions/status-check';

import { usePatientInfo } from './use-patient-info';

export const useCheckPatientModule = (patientGuid: string) => {
  const { patientInfo, loading } = usePatientInfo({
    patientGuid,
  });

  const isBlockCcmModule = patientInfo?.ccmStatus
    ? hasStatusForDisableCcmModule(patientInfo.ccmStatus)
    : true;

  const isBlockRpmModule = patientInfo?.status
    ? hasStatusForDisableRpmModule(patientInfo.status)
    : true;

  const isReadonlyRpmModule = patientInfo?.status
    ? hasStatusForReadonlyRpmModule(patientInfo.status)
    : true;

  const isReadonlyCcmModule = patientInfo?.ccmStatus
    ? hasStatusForReadonlyCcmModule(patientInfo.ccmStatus)
    : true;

  return {
    isBlockCcmModule,
    isBlockRpmModule,
    isReadonlyRpmModule,
    isReadonlyCcmModule,
    loading,
  };
};
